module.exports = __webpack_public_path__ + "static/img/d6-1sk.bee1026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english/home/mobile/role/d6-1sk.png
// module id = 07oD
// module chunks = 0